module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Elizabeth Gaskell\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Elizabeth Gaskell (1810–1865) was an English author and social activist best known for her novel "), _c('I', [_vm._v("North and South")]), _vm._v(", a searing portrait of the industrial revolution and the tale of an unlikely romance between a beautiful and headstrong minister’s daughter and a combative mill owner.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/BmxKD4/tc-custom/9781504083386.jpg?1728954683976",
      "alt": "This image is the cover for the book Half A Lifetime Ago"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Half A Lifetime Ago\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("A farmer in nineteenth-century England is torn between love and her sense of duty in this novella by the author of "), _c('i', [_vm._v("Wives and Daughters")]), _vm._v(" and "), _c('i', [_vm._v("Cranford")]), _vm._v(".")])]), _vm._v(" Susan Dixon is a hardworking, respected farmer living alone in the Westmorland Dales in northwest England. But that wasn’t always the case. She was once surrounded by her father and mother, her brother, and her beloved, the handsome Michael Hurst. Time and time again, Susan is put to the test as tragedy forces her to make difficult decisions that will affect the lives of those around her as well as her own . . .\n    "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0